import { useNavigate } from 'react-router-dom';
import React from 'react';
import { CardSimple } from '../../ui';
import logo from '../../ui/assets/logo.png';
import { Page } from '../../components';
import { IT } from 'country-flag-icons/react/3x2';
import { useLang } from '../../libs';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import HomeOutlined from '@mui/icons-material/StorefrontOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import NfcOutlinedIcon from '@mui/icons-material/NfcOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';

const translations = {
    it: {
        heroTitle: "Certifica l'Autenticit\u00E0 delle Tue Opere con un Tocco",
        heroText: <>Tag NFC invisibili integrati nelle opere d{"'"}arte, collegati a un certificato digitale permanente nel cloud. Nessuna app, nessun QR code — basta sfiorare con lo smartphone.</>,
        heroSampleBtn: "Richiedi un Campione Gratuito",
        heroDemoBtn: "Prenota una Demo",
        heroSampleSubject: "Richiesta%20campione%20NFC%20Arte",
        heroDemoSubject: "Prenotazione%20demo%20arte",
        problemTitle: "Il Problema",
        problemText: <>Il mercato dell{"'"}arte ha un problema serio di autenticazione. I numeri parlano chiaro.</>,
        stat1Value: "50%",
        stat1Text: "delle opere in circolazione potrebbe essere falso o mal attribuito",
        stat1Source: "Swiss Fine Art Expert Institute",
        stat2Value: "2.804",
        stat2Text: "opere false sequestrate nel 2024 per \u20AC311 milioni",
        stat2Source: "Carabinieri TPC",
        stat3Value: "450",
        stat3Text: "certificati cartacei contraffatti trovati in una sola operazione",
        stat4Value: "\u20AC200-300",
        stat4Text: "costo medio per autenticazione tradizionale — insostenibile per l'81% del mercato",
        solutionTitle: "La Soluzione Kangury",
        sol1Title: "1. Applica il Tag NFC",
        sol1Text: "Un tag NFC sottile e invisibile viene applicato all'opera o alla cornice. Non altera l'estetica.",
        sol2Title: "2. Carica il Certificato nel Cloud",
        sol2Text: "Certificato di autenticita, foto HD, video, scheda tecnica — tutto in uno spazio cloud permanente.",
        sol3Title: "3. Il Cliente Verifica con un Tocco",
        sol3Text: "Basta avvicinare lo smartphone all'opera per accedere al certificato digitale. Nessuna app richiesta.",
        solutionFooter: "Nessuna app da scaricare. Compatibile con il 95%+ degli smartphone. Verifica istantanea.",
        cloudTitle: "Cosa Puoi Includere nel Cloud",
        cloudSubtitle: "Tutto aggiornabile nel tempo, anche dopo la vendita.",
        cloudCert: "Certificato di Autenticit\u00E0",
        cloudCertSub: "PDF firmato digitalmente",
        cloudPhotos: "Foto HD dell'Opera",
        cloudPhotosSub: "Dettagli ad alta risoluzione",
        cloudVideo: "Video del Processo Creativo",
        cloudVideoSub: "Time-lapse, interviste, backstage",
        cloudTech: "Scheda Tecnica",
        cloudTechSub: "Dimensioni, tecnica, materiali",
        cloudBio: "Biografia dell'Artista",
        cloudBioSub: "Curriculum, mostre, premi",
        cloudHistory: "Storia Esposizioni e Provenance",
        cloudHistorySub: "Tracciamento completo",
        useCasesTitle: <>Casi d{"'"}Uso</>,
        uc1Title: "Gallerie d'arte",
        uc1Sub: "Certificare originali e edizioni limitate",
        uc2Title: "Stamperie d'arte",
        uc2Sub: "Autenticare serigrafie e gicl\u00E9e numerate",
        uc3Title: "Case d'asta",
        uc3Sub: "Provenance tracking per ogni lotto",
        uc4Title: "Artisti indipendenti",
        uc4Sub: "Certificare le proprie opere a basso costo",
        uc5Title: "Fiere d'arte",
        uc5Sub: "Servizio di certificazione per espositori",
        uc6Title: "Marketplace online",
        uc6Sub: "Aggiungere layer di fiducia",
        whyTitle: "Perch\u00E9 Kangury invece dei Competitor",
        why1Title: "Nessuna app da scaricare",
        why1Text: "Arteia e Blockchain Art Collective richiedono app dedicate. Kangury funziona con un semplice tocco.",
        why2Title: "Da \u20AC2/tag",
        why2Text: "\u20AC200-300 per un'autenticazione tradizionale? Con Kangury il costo parte da \u20AC2 per tag.",
        why3Title: "Cloud aggiornabile per sempre",
        why3Text: "I certificati cartacei sono statici. Il cloud Kangury si aggiorna quando vuoi, anche dopo la vendita.",
        why4Title: "Made in Italy",
        why4Text: "Prodotto e gestito dall'Italia, a differenza dei competitor USA e Svizzera.",
        why5Title: "Nessun costo ricorrente",
        why5Text: "Verisart costa $30-100/mese. Con Kangury si paga una volta, il cloud \u00E8 incluso per sempre.",
        why6Title: "Pronto all'uso",
        why6Text: "Nessuna blockchain complessa da capire. Plug & play: ricevi il tag, applica, carica i contenuti.",
        pricingTitle: "Pricing",
        pricingSubtitle: "Cloud incluso per sempre. Nessun abbonamento.",
        pricingNote: "I prezzi sono indicativi e possono variare in base alla quantità e personalizzazione. Contattaci per un preventivo su misura.",
        marketTitle: "Dati di Mercato",
        market1Value: "\u20AC1,36 mld",
        market1Text: "Mercato arte Italia",
        market2Value: "5%",
        market2Text: "IVA ridotta dal 2025",
        market3Value: "+35%",
        market3Text: "Crescita autenticazione digitale annua",
        market4Value: "3.255",
        market4Text: "Gallerie e antiquari in Italia",
        ctaTitle: "Proteggi le tue opere. Conquista la fiducia dei collezionisti.",
        ctaText: "Richiedi un campione gratuito personalizzato e scopri come Kangury può proteggere e valorizzare il tuo lavoro.",
        ctaSampleBtn: "Richiedi un campione gratuito",
        ctaDemoBtn: "Prenota una Demo",
        socialTitle: "Seguici sui nostri social",
        contactTitle: "Per informazioni contattaci:",
        sourceLabel: "Fonte",
        perTag: "per tag",
    },
    en: {
        heroTitle: "Certify the Authenticity of Your Artworks with a Touch",
        heroText: <>Invisible NFC tags integrated into artworks, linked to a permanent digital certificate in the cloud. No app, no QR code — just tap with your smartphone.</>,
        heroSampleBtn: "Request a Free Sample",
        heroDemoBtn: "Book a Demo",
        heroSampleSubject: "NFC%20Art%20sample%20request",
        heroDemoSubject: "Art%20demo%20booking",
        problemTitle: "The Problem",
        problemText: <>The art market has a serious authentication problem. The numbers speak for themselves.</>,
        stat1Value: "50%",
        stat1Text: "of artworks in circulation could be fake or misattributed",
        stat1Source: "Swiss Fine Art Expert Institute",
        stat2Value: "2,804",
        stat2Text: "fake artworks seized in 2024 worth \u20AC311 million",
        stat2Source: "Carabinieri TPC",
        stat3Value: "450",
        stat3Text: "counterfeit paper certificates found in a single operation",
        stat4Value: "\u20AC200-300",
        stat4Text: "average cost for traditional authentication — unsustainable for 81% of the market",
        solutionTitle: "The Kangury Solution",
        sol1Title: "1. Apply the NFC Tag",
        sol1Text: "A thin, invisible NFC tag is applied to the artwork or frame. It doesn't alter the aesthetics.",
        sol2Title: "2. Upload the Certificate to the Cloud",
        sol2Text: "Certificate of authenticity, HD photos, video, technical sheet — all in a permanent cloud space.",
        sol3Title: "3. The Client Verifies with a Touch",
        sol3Text: "Just bring the smartphone close to the artwork to access the digital certificate. No app required.",
        solutionFooter: "No app to download. Compatible with 95%+ of smartphones. Instant verification.",
        cloudTitle: "What You Can Include in the Cloud",
        cloudSubtitle: "Everything updatable over time, even after the sale.",
        cloudCert: "Certificate of Authenticity",
        cloudCertSub: "Digitally signed PDF",
        cloudPhotos: "HD Photos of the Artwork",
        cloudPhotosSub: "High-resolution details",
        cloudVideo: "Creative Process Video",
        cloudVideoSub: "Time-lapse, interviews, backstage",
        cloudTech: "Technical Sheet",
        cloudTechSub: "Dimensions, technique, materials",
        cloudBio: "Artist Biography",
        cloudBioSub: "CV, exhibitions, awards",
        cloudHistory: "Exhibition History & Provenance",
        cloudHistorySub: "Complete tracking",
        useCasesTitle: "Use Cases",
        uc1Title: "Art galleries",
        uc1Sub: "Certify originals and limited editions",
        uc2Title: "Art print studios",
        uc2Sub: "Authenticate numbered serigraphs and gicl\u00E9es",
        uc3Title: "Auction houses",
        uc3Sub: "Provenance tracking for every lot",
        uc4Title: "Independent artists",
        uc4Sub: "Certify your own works at low cost",
        uc5Title: "Art fairs",
        uc5Sub: "Certification service for exhibitors",
        uc6Title: "Online marketplaces",
        uc6Sub: "Add a layer of trust",
        whyTitle: "Why Kangury over the Competition",
        why1Title: "No app to download",
        why1Text: "Arteia and Blockchain Art Collective require dedicated apps. Kangury works with a simple touch.",
        why2Title: "From \u20AC2/tag",
        why2Text: "\u20AC200-300 for traditional authentication? With Kangury the cost starts at \u20AC2 per tag.",
        why3Title: "Cloud updatable forever",
        why3Text: "Paper certificates are static. Kangury's cloud updates whenever you want, even after the sale.",
        why4Title: "Made in Italy",
        why4Text: "Produced and managed from Italy, unlike US and Swiss competitors.",
        why5Title: "No recurring costs",
        why5Text: "Verisart costs $30-100/month. With Kangury you pay once, cloud included forever.",
        why6Title: "Ready to use",
        why6Text: "No complex blockchain to understand. Plug & play: receive the tag, apply it, upload your content.",
        pricingTitle: "Pricing",
        pricingSubtitle: "Cloud included forever. No subscription.",
        pricingNote: "Prices are indicative and may vary based on quantity and customisation. Contact us for a tailored quote.",
        marketTitle: "Market Data",
        market1Value: "\u20AC1.36 bn",
        market1Text: "Italian art market",
        market2Value: "5%",
        market2Text: "Reduced VAT from 2025",
        market3Value: "+35%",
        market3Text: "Annual digital authentication growth",
        market4Value: "3,255",
        market4Text: "Galleries and antique dealers in Italy",
        ctaTitle: "Protect your artworks. Win the trust of collectors.",
        ctaText: "Request a free personalised sample and discover how Kangury can protect and enhance your work.",
        ctaSampleBtn: "Request a free sample",
        ctaDemoBtn: "Book a Demo",
        socialTitle: "Follow us on social media",
        contactTitle: "For information, contact us:",
        sourceLabel: "Source",
        perTag: "per tag",
    },
};

export function BusinessArte() {
    const navigate = useNavigate();
    const lang = useLang();
    const t = translations[lang];

    const arrowClick = () => {
        window.history.back();
    }

    const homeClick = () => {
        navigate('/');
    }

    return (<Page visibleBottomNavigation={false}>
        <div>
            {/* Header */}
            <div className='landing-page w-100 d-flex justify-content-center align-items-center text-primary border-bottom border-2 bg-tertiary'>
                <button className='btn btn-link' onClick={arrowClick}>
                    <ArrowBackOutlinedIcon fontSize="large" className="fs-4" />
                </button>
                <div className='container d-flex justify-content-center align-items-center'>
                    <img src={logo} alt="logo" style={{ height: '50px' }} className='pe-none' unselectable="on" />
                    <span className='fw-bold fs-1'>
                        Kangury
                    </span>
                </div>
                <button className='btn btn-link'>
                    <HomeOutlined fontSize="large" className="fs-4 text-primary" onClick={homeClick} />
                </button>
            </div>

            {/* ===================== HERO SECTION ===================== */}
            <div className="w-100 p-4 d-flex justify-content-center align-items-center bg-tertiary pt-5 pb-5">
                <div className="container">
                    <div className="text-center">
                        <VerifiedOutlinedIcon className="text-primary mb-3" style={{ fontSize: '64px' }} />
                        <h1 className='fw-bold mb-3 text-primary'>
                            {t.heroTitle}
                        </h1>
                        <p className='fs-5 mb-4 text-white' style={{ maxWidth: '750px', margin: '0 auto' }}>
                            {t.heroText}
                        </p>
                        <div className='d-flex justify-content-center gap-3 flex-wrap'>
                            <a href={`mailto:hello@kangury.it?subject=${t.heroSampleSubject}`}
                                className='btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                                {t.heroSampleBtn}
                            </a>
                            <a href={`mailto:hello@kangury.it?subject=${t.heroDemoSubject}`}
                                className='btn rounded-5 fs-6 btn-outline-primary text-primary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                                <CalendarMonthOutlinedIcon className='me-2' style={{ fontSize: '20px' }} />
                                {t.heroDemoBtn}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className='horizontal-line' />

            {/* ===================== IL PROBLEMA ===================== */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-3 text-tertiary'>
                    {t.problemTitle}
                </h2>
                <p className='text-center mb-5' style={{ color: '#555', maxWidth: '650px', margin: '0 auto' }}>
                    {t.problemText}
                </p>
                <div className='row'>
                    <div className='col-12 col-md-6 mb-4 ps-4 pe-4'>
                        <StatCard
                            value={t.stat1Value}
                            text={t.stat1Text}
                            source={t.stat1Source}
                            sourceLabel={t.sourceLabel}
                            icon={<WarningAmberOutlinedIcon className='text-primary' style={{ fontSize: '36px' }} />}
                        />
                    </div>
                    <div className='col-12 col-md-6 mb-4 ps-4 pe-4'>
                        <StatCard
                            value={t.stat2Value}
                            text={t.stat2Text}
                            source={t.stat2Source}
                            sourceLabel={t.sourceLabel}
                            icon={<GavelOutlinedIcon className='text-primary' style={{ fontSize: '36px' }} />}
                        />
                    </div>
                    <div className='col-12 col-md-6 mb-4 ps-4 pe-4'>
                        <StatCard
                            value={t.stat3Value}
                            text={t.stat3Text}
                            source=""
                            sourceLabel={t.sourceLabel}
                            icon={<DescriptionOutlinedIcon className='text-primary' style={{ fontSize: '36px' }} />}
                        />
                    </div>
                    <div className='col-12 col-md-6 mb-4 ps-4 pe-4'>
                        <StatCard
                            value={t.stat4Value}
                            text={t.stat4Text}
                            source=""
                            sourceLabel={t.sourceLabel}
                            icon={<PaymentOutlinedIcon className='text-primary' style={{ fontSize: '36px' }} />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== LA SOLUZIONE KANGURY ===================== */}
            <Section>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    {t.solutionTitle}
                </h2>
                <div className='row'>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.sol1Title}
                            text1={t.sol1Text}
                            icon={<NfcOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.sol2Title}
                            text1={t.sol2Text}
                            icon={<CloudUploadOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.sol3Title}
                            text1={t.sol3Text}
                            icon={<TouchAppOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                </div>
                <div className='text-center mt-3'>
                    <p className='fw-bold text-tertiary fs-5'>
                        {t.solutionFooter}
                    </p>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== COSA PUOI INCLUDERE NEL CLOUD ===================== */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-3 text-tertiary'>
                    {t.cloudTitle}
                </h2>
                <p className='text-center mb-5' style={{ color: '#555' }}>
                    {t.cloudSubtitle}
                </p>
                <div className='row'>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudCert}
                            subtitle={t.cloudCertSub}
                            icon={<VerifiedOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudPhotos}
                            subtitle={t.cloudPhotosSub}
                            icon={<PhotoLibraryOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudVideo}
                            subtitle={t.cloudVideoSub}
                            icon={<VideocamOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudTech}
                            subtitle={t.cloudTechSub}
                            icon={<BuildOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudBio}
                            subtitle={t.cloudBioSub}
                            icon={<PersonOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.cloudHistory}
                            subtitle={t.cloudHistorySub}
                            icon={<HistoryOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== CASI D'USO ===================== */}
            <Section>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    {t.useCasesTitle}
                </h2>
                <div className='row'>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc1Title}
                            subtitle={t.uc1Sub}
                            icon={<PaletteOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc2Title}
                            subtitle={t.uc2Sub}
                            icon={<PrintOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc3Title}
                            subtitle={t.uc3Sub}
                            icon={<GavelOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc4Title}
                            subtitle={t.uc4Sub}
                            icon={<BrushOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc5Title}
                            subtitle={t.uc5Sub}
                            icon={<StorefrontOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title={t.uc6Title}
                            subtitle={t.uc6Sub}
                            icon={<ShoppingCartOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== PERCHE KANGURY INVECE DEI COMPETITOR ===================== */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    {t.whyTitle}
                </h2>
                <div className='row'>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why1Title}
                            text1={t.why1Text}
                            icon={<SmartphoneOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why2Title}
                            text1={t.why2Text}
                            icon={<PaymentOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why3Title}
                            text1={t.why3Text}
                            icon={<CloudSyncOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why4Title}
                            text1={t.why4Text}
                            icon={<FlagOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why5Title}
                            text1={t.why5Text}
                            icon={<BlockOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title={t.why6Title}
                            text1={t.why6Text}
                            icon={<SpeedOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== PRICING ===================== */}
            <Section>
                <h2 className='fw-bold w-100 text-center mb-3 text-tertiary'>
                    {t.pricingTitle}
                </h2>
                <p className='text-center text-tertiary mb-5'>
                    {t.pricingSubtitle}
                </p>
                <div className='row justify-content-center'>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='10 – 50 pz'
                            price={"\u20AC5/tag"}
                            perTag={t.perTag}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='50 – 200 pz'
                            price={"\u20AC3,50/tag"}
                            perTag={t.perTag}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='200 – 500 pz'
                            price={"\u20AC2,50/tag"}
                            perTag={t.perTag}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='1000+ pz'
                            price={"\u20AC2/tag"}
                            highlight={true}
                            perTag={t.perTag}
                        />
                    </div>
                </div>
                <p className='text-center text-tertiary mt-2' style={{ fontSize: '14px' }}>
                    {t.pricingNote}
                </p>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== DATI DI MERCATO ===================== */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    {t.marketTitle}
                </h2>
                <div className='row'>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <StatCardSmall
                            value={t.market1Value}
                            text={t.market1Text}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <StatCardSmall
                            value={t.market2Value}
                            text={t.market2Text}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <StatCardSmall
                            value={t.market3Value}
                            text={t.market3Text}
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <StatCardSmall
                            value={t.market4Value}
                            text={t.market4Text}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* ===================== CTA FINALE ===================== */}
            <Section>
                <div className='text-center text-tertiary'>
                    <h2 className='fw-bold mb-3'>{t.ctaTitle}</h2>
                    <p className='fs-5 mb-4' style={{ maxWidth: '600px', margin: '0 auto' }}>
                        {t.ctaText}
                    </p>
                    <div className='d-flex justify-content-center gap-3 flex-wrap mb-4'>
                        <a href={`mailto:hello@kangury.it?subject=${t.heroSampleSubject}`}
                            className='btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            <EmailOutlinedIcon className='me-2' style={{ fontSize: '20px' }} />
                            {t.ctaSampleBtn}
                        </a>
                        <a href={`mailto:hello@kangury.it?subject=${t.heroDemoSubject}`}
                            className='btn rounded-5 fs-6 btn-tertiary text-primary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            <CalendarMonthOutlinedIcon className='me-2' style={{ fontSize: '20px' }} />
                            {t.ctaDemoBtn}
                        </a>
                    </div>
                    <div className='fs-5'>
                        <a href="mailto:hello@kangury.it" className='text-tertiary'>hello@kangury.it</a>
                    </div>
                </div>
            </Section>

            {/* ===================== SOCIAL / CONTACT FOOTER ===================== */}
            <div className="w-100 p-4 d-flex justify-content-center align-items-center bg-tertiary bg-opacity-50 pt-5 pb-5">
                <div className="container">
                    <h2 className="fw-bold w-100 text-center mb-3 text-tertiary">
                        {t.socialTitle}
                    </h2>
                    <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
                        <a href="https://www.instagram.com/kanguryapp/" target="_blank" rel="noreferrer">
                            <InstagramIcon fontSize="large" className="text-primary" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=61563829343302" target="_blank" rel="noreferrer">
                            <FacebookIcon fontSize="large" className="text-primary" />
                        </a>
                        <a href="https://www.youtube.com/@kangury" target="_blank" rel="noreferrer">
                            <YouTubeIcon fontSize="large" className="text-primary" />
                        </a>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                        <IT style={{ height: '15px' }} />
                        <em className="me-2 ms-2">Made in Italy</em>
                        <IT style={{ height: '15px' }} />
                    </div>
                    <h5 className="fw-bold w-100 text-tertiary text-center">
                        {t.contactTitle}
                    </h5>
                    <div className="fs-5 text-center">
                        <a href="mailto:hello@kangury.it" className="text-tertiary">hello@kangury.it</a>
                    </div>
                </div>
            </div>

            {/* ===================== COPYRIGHT FOOTER ===================== */}
            <div className='w-100 d-flex justify-content-center align-items-center text-primary bg-tertiary' style={{ padding: '12px 0' }}>
                <img src={logo} alt="logo" style={{ height: '30px' }} className='pe-none me-2' unselectable="on" />
                Kangury | Copyright &copy; 2024
            </div>

        </div>
    </Page>);
}

const Card = ({ title, text1, text2, otherClass, icon }) => {
    return (
        <CardSimple
            otherClass={otherClass ?? "bg-tertiary bg-opacity-75 position-relative h-100 shadow"}
            children={<div className='text-center'>
                <div className='fs-5 fw-bold text-primary'>{title}</div>
                <div className='fw-bold text-white'>
                    {text1}
                </div>
                {text2 && <div className='fw-bold text-white'>
                    {text2}
                </div>}
                {icon}
            </div>} />
    );
}

const UseCaseCard = ({ title, subtitle, icon }) => {
    return (
        <CardSimple
            otherClass="bg-tertiary bg-opacity-75 h-100 shadow text-center d-flex flex-column align-items-center justify-content-center"
            children={<div>
                {icon}
                <div className='fs-6 fw-bold text-primary mt-2'>{title}</div>
                {subtitle && <div className='text-white' style={{ fontSize: '13px' }}>{subtitle}</div>}
            </div>} />
    );
}

const PricingCard = ({ quantity, price, highlight, perTag }) => {
    return (
        <CardSimple
            otherClass={`h-100 shadow text-center ${highlight ? 'bg-primary' : 'bg-tertiary bg-opacity-75'}`}
            children={<div>
                <div className={`fs-6 fw-bold ${highlight ? 'text-tertiary' : 'text-primary'}`}>{quantity}</div>
                <div className={`fs-4 fw-bold mt-2 ${highlight ? 'text-tertiary' : 'text-white'}`}>{price}</div>
                <div className={`mt-1 ${highlight ? 'text-tertiary' : 'text-white'}`} style={{ fontSize: '13px' }}>{perTag}</div>
            </div>} />
    );
}

const StatCard = ({ value, text, source, sourceLabel, icon }) => {
    return (
        <CardSimple
            otherClass="bg-tertiary bg-opacity-75 h-100 shadow"
            children={<div className='text-center'>
                {icon}
                <div className='fs-2 fw-bold text-primary mt-2'>{value}</div>
                <div className='fw-bold text-white mt-1'>{text}</div>
                {source && <div className='text-white mt-2' style={{ fontSize: '12px', opacity: 0.7 }}>
                    {sourceLabel}: {source}
                </div>}
            </div>} />
    );
}

const StatCardSmall = ({ value, text }) => {
    return (
        <CardSimple
            otherClass="bg-tertiary bg-opacity-75 h-100 shadow text-center d-flex flex-column align-items-center justify-content-center"
            children={<div>
                <div className='fs-3 fw-bold text-primary'>{value}</div>
                <div className='text-white fw-bold mt-1' style={{ fontSize: '14px' }}>{text}</div>
            </div>} />
    );
}

const Section = ({ children, bgWhite }) => {
    return (
        <div className={`w-100 p-4 d-flex justify-content-center align-items-center ${bgWhite ? 'bg-white' : 'bg-tertiary bg-opacity-25'} pt-5 pb-5`}>
            <div className="container">
                {children}
            </div>
        </div>
    );
}
